import React from 'react'
import "./section.css";


const Section = () => {
    return( 
    <div id="sec-text">
      <h4> Trees are vital</h4>
      <ul>
          <li>for the purification of air</li>
          <li>to produce oxygen</li>
          <li>to store carbon</li>
          <li>as homes for many birds and animals</li>
          <li>for energy conservation</li>
      </ul>
    </div>
     
    )
}

  

export default Section;